import request from '@/utils/request'
import store from '@/store'

/**
 * 获取协议详情接口
 * @param { protocolId, versionId } params
 * @returns
 */
export function protocolDetail (params) {
  return request({
    method: 'GET',
    url: store.getters.baseUrl + 'vstore-api/mall-cms-oversea/protocol/versionDetail',
    params
  })
}

/**
   * 获取协议历史列表接口
   * @param { protocolId } params
   * @returns
   */
export function protocolList (params) {
  return request({
    method: 'GET',
    url: store.getters.baseUrl + 'vstore-api/mall-cms-oversea/protocol/versionHistory',
    params
  })
}

/**
   * 查询和该protocolId同类型的其他语言版本,有protocolType则以后端以protocolType为准
   * @param { protocolId, versionId,protocolType } params
   * @returns
   */
export function sameTypeProtocolList (params) {
  return request({
    method: 'GET',
    url: store.getters.baseUrl + 'vstore-api/mall-cms-oversea/protocol/versionDetail/list',
    params
  })
}
